export default "__VITE_ASSET__26fecb08__"